module.exports = __webpack_public_path__ + "img/home_dy.6e6579db.png";